"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RichTextContentType;
(function (RichTextContentType) {
    RichTextContentType["Item"] = "item";
})(RichTextContentType = exports.RichTextContentType || (exports.RichTextContentType = {}));
//# sourceMappingURL=modular-item-type.enum.js.map